module.exports = __webpack_public_path__ + "media/images/athletes/3577-ec6fffd4ed2aadbcc85476f01bb3d4e9.png";